import PlaceholderScreen from '../../components/PlaceholderScreen/PlaceholderScreen'

export default function LoPerformanceReportScreen() {
  return (
    <PlaceholderScreen
      icon="🏆"
      title="LO Performance Report"
      subtitle="This report shows officer metrics, rankings, and performance analytics. This report will be available in a future update."
    />
  )
}
